import { render, staticRenderFns } from "./VersionUpdateModal.vue?vue&type=template&id=6d635e9a&scoped=true"
import script from "./VersionUpdateModal.vue?vue&type=script&lang=js"
export * from "./VersionUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d635e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d635e9a')) {
      api.createRecord('6d635e9a', component.options)
    } else {
      api.reload('6d635e9a', component.options)
    }
    module.hot.accept("./VersionUpdateModal.vue?vue&type=template&id=6d635e9a&scoped=true", function () {
      api.rerender('6d635e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/versionUpdate/modules/VersionUpdateModal.vue"
export default component.exports